/**
 * @generated SignedSource<<0bd4f280d41db59093392a1ca0b0d63a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
export type GraphQLLlmConversationSource = "AGENT_EVAL_REGRESSION_JUDGE" | "ALERT_REMEDIATION" | "ALERT_RUNBOOK_HOOK" | "API" | "EVAL" | "INCIDENT" | "INTERNAL_AGENT" | "JOB" | "JOB_AGENT_DASHBOARD_SECTION" | "LINEAR" | "MCP_CLIENT" | "OPTIMIZER_CONFIGURATION" | "OPTIMIZER_ISSUE_REVISION" | "OPTIMIZER_PROPOSAL" | "OPTIMIZER_RUN" | "PR_IMPLEMENTATION" | "SLACK" | "STUDIO" | "SYSTEM" | "UI" | "WORKFLOW_MEMORY" | "WORKFLOW_MEMORY_CONSOLIDATE" | "WORKFLOW_MEMORY_EVAL" | "WORKFLOW_MEMORY_SHADOW_DIGEST" | "%future added value";
export type GraphQLLlmInteractionStatus = "COMPLETED" | "FAILED" | "INTERRUPTED" | "IN_PROGRESS" | "PENDING" | "SKIPPED" | "%future added value";
export type GraphQLMessageMessageRole = "AGENT" | "HUMAN" | "%future added value";
export type GraphQLMessageMessageType = "AGENT_PROCESS" | "AGENT_RESPONSE" | "ERROR_RESPONSE" | "USER_INPUT" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type LlmConversationChatContent_llmConversation$data = {
  readonly conversationId: number | null | undefined;
  readonly createdAt: any;
  readonly hasUnreadResponse: boolean;
  readonly id: any;
  readonly llmInteractions: ReadonlyArray<{
    readonly id: any;
    readonly status: GraphQLLlmInteractionStatus;
    readonly statusMessage: string | null | undefined;
  }>;
  readonly messages: ReadonlyArray<{
    readonly content: string;
    readonly id: string;
    readonly messageMetadata: {
      readonly usage: {
        readonly billingTokens: number;
      } | null | undefined;
    } | null | undefined;
    readonly messageRole: GraphQLMessageMessageRole;
    readonly messageType: GraphQLMessageMessageType | null | undefined;
  }>;
  readonly metadataJson: any | null | undefined;
  readonly source: GraphQLLlmConversationSource | null | undefined;
  readonly sourceId: string | null | undefined;
  readonly updatedAt: any;
  readonly " $fragmentSpreads": FragmentRefs<"LlmConversationMessageList_llmConversation">;
  readonly " $fragmentType": "LlmConversationChatContent_llmConversation";
};
export type LlmConversationChatContent_llmConversation$key = {
  readonly " $data"?: LlmConversationChatContent_llmConversation$data;
  readonly " $fragmentSpreads": FragmentRefs<"LlmConversationChatContent_llmConversation">;
};

import LlmConversationChatContentRefetchQuery_graphql from './LlmConversationChatContentRefetchQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "node"
      ],
      "operation": LlmConversationChatContentRefetchQuery_graphql,
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "LlmConversationChatContent_llmConversation",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "source",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sourceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "metadataJson",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "conversationId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasUnreadResponse",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "last",
          "value": 10
        }
      ],
      "concreteType": "GraphQLLlmInteraction",
      "kind": "LinkedField",
      "name": "llmInteractions",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "statusMessage",
          "storageKey": null
        }
      ],
      "storageKey": "llmInteractions(last:10)"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "GraphQLFormattedMessage",
      "kind": "LinkedField",
      "name": "messages",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "messageRole",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "messageType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "content",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "GraphQLMessageMetadata",
          "kind": "LinkedField",
          "name": "messageMetadata",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "GraphQLUsageTokens",
              "kind": "LinkedField",
              "name": "usage",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "billingTokens",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "LlmConversationMessageList_llmConversation"
    }
  ],
  "type": "GraphQLLlmConversation",
  "abstractKey": null
};
})();

(node as any).hash = "60b540534b6e975e3495ea2e15a1a31a";

export default node;
